// --- 人员管理 --- //

export default [
  {
    name: 'staffManagement',
    path: '/carWashSuperviseSystem/:carWashId/staffManagement',
    meta: { title: '人员管理' },
    component: require('business/carWashSuperviseSystem/staffManagement/list.vue').default
  }
]
